import * as z from "zod";

/** The latest pull on one arm of a span test. */
const shopperAgentTestPull = z.object({
  arm: z.string(),
  /** What the arm's open spans run from their next message; null once lifted. */
  runsArm: z.string().nullable(),
  pulledBy: z.string(),
  reason: z.string(),
  pulledAt: z.date(),
});

/** A span test row, the latest pull on each arm, and spans assigned per arm. */
export const shopperAgentTestStatus = z.object({
  testId: z.string(),
  kind: z.string(),
  /** Null when arm picking can't read the row, so new spans skip the test. */
  weights: z.record(z.string(), z.number()).nullable(),
  startedAt: z.date(),
  stoppedAt: z.date().nullable(),
  pulls: z.array(shopperAgentTestPull),
  spans: z.record(z.string(), z.number()),
});

export type ShopperAgentTestStatus = z.infer<typeof shopperAgentTestStatus>;
